import { useTranslation } from 'react-i18next'
import { NBSP, formatAmount } from '@dorixona/utils'

/**
 * Кэшбэк и баланс карты — в баллах, не в сумах (1 балл = 1 сум):
 * 3 → «3 балла», 3800 → «3 800 баллов» · «3 800 ball».
 */
export function usePoints() {
  const { t } = useTranslation('common')
  return {
    formatPoints: (amount: number) => `${formatAmount(amount)}${NBSP}${pointsUnit(amount)}`,
    pointsUnit,
  }

  function pointsUnit(amount: number): string {
    return t('common:pointsUnit', { count: Math.abs(Math.round(amount)) })
  }
}
